import React, { useEffect, useRef } from 'react';
import { Modal } from 'semantic-ui-react';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import MainButton from 'components/Buttons/MainButton';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import Select from 'components/Form/Select';

const schemaValidation = Yup.object().shape({
	documentType: Yup.number().required('Champ requis'),
});

const DocumentTypeModal = ({ close, options, submit, defaultValue = null }) => {
	const innerRef = useRef(null);

	useEffect(() => {
		// subscribe event
		document.body.addEventListener('keyup', enterEventListener);
		return () => {
			// unsubscribe event
			document.body.addEventListener('keyup', enterEventListener);
		};
	}, []);

	const enterEventListener = (e) => {
		const button = innerRef.current;
		if (button) button.props.onClick();
	};

	return (
		<Formik
			initialValues={{
				documentType: defaultValue,
			}}
			validationSchema={schemaValidation}
			onSubmit={(values) => {
				submit(values.documentType);
			}}
		>
			{({ submitForm }) => {
				return (
					<Form>
						<Modal
							open
							onClose={close}
							closeOnEscape
							closeOnDimmerClick
							size='small'
						>
							<Modal.Header>Type de document</Modal.Header>
							<Modal.Content>
								<Field
									component={Select}
									name='documentType'
									customlabel='Veuillez sélectionner un type de document'
									placeholder='Sélectionner un type de document'
									options={options.map((option) => {
										return {
											value: option.id,
											label: option.title,
										};
									})}
								/>
							</Modal.Content>
							<Modal.Actions>
								<MainButton
									ref={innerRef}
									text='Confirmer'
									onClick={submitForm}
								/>
								<SecondaryButton onClick={() => close()}>
									Annuler
								</SecondaryButton>
							</Modal.Actions>
						</Modal>
					</Form>
				);
			}}
		</Formik>
	);
};

export default DocumentTypeModal;
